module.exports = __webpack_public_path__ + "img/activity_41.d4f84b20.png";